import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoltIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 11 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#3c5957",
		d: "M5.834 0 0 7.2h5.25L4.666 12 10.5 4.8H5.25z"
	})
});
export default SvgBoltIcon;
